import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

export const INDIVIDUAL_MONITORING_WATCHLIST_QUERY_KEYS = {
    list: ["individual-monitoring-watchlist", "list"],
    detail: (id) => ["individual-monitoring-watchlist", "detail", id],
    status: ["facial-recognition-status"],
};

const IndividualMonitoringWatchlistService = {
    list: () => axios.get(API_KEEPER + "/individual-monitoring-watchlist/list").then(({ data }) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + "/individual-monitoring-watchlist/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_KEEPER + "/individual-monitoring-watchlist", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (data) => axios.put(API_KEEPER + "/individual-monitoring-watchlist", data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_KEEPER + "/individual-monitoring-watchlist/" + id).catch((err) => { throw err }),

    getOptions: async () => axios.get(API_KEEPER + "/individual-monitoring-watchlist/get/options").then(({data}) => data).catch((err) => { throw err }),

    status: async () => axios.get(API_KEEPER + "/facial-recognition/status").then(({data}) => data).catch((err) => { throw err }),
};

export default IndividualMonitoringWatchlistService;
